import { createContext } from 'react';

export const ContainerContext = createContext({
  getContainer(): HTMLElement {
    return document.body;
  },
});
